import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  class: "header align-items-stretch headerMargin"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-none btn btn-icon btn-active-light-primary",
  id: "kt_aside_mobile_toggle"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "align-items-center flex-grow-1 flex-lg-grow-0" }, null, -1)
const _hoisted_4 = { class: "align-items-stretch justify-content-stretch" }
const _hoisted_5 = {
  class: "align-items-stretch",
  id: "kt_header_menu_nav"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTLogos = _resolveComponent("KTLogos")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "align-items-stretch justify-content-between"])
    }, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_KTLogos)
        ])
      ])
    ], 2)
  ]))
}